/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Breadcrumb } from '@carbon/react';

var _excluded = ["href", "onClick", "value", "asButton", "asCustomComponent"];

/**
 * Checks the type of breadcrumb and returns the appropriate component
 * @param {Object} breadcrumb props
 * @param {Object} LinkComponent
 */
var getBreadcrumbValue = function getBreadcrumbValue(breadcrumb, LinkComponent) {
  var href = breadcrumb.href,
    onClick = breadcrumb.onClick,
    value = breadcrumb.value,
    asButton = breadcrumb.asButton,
    asCustomComponent = breadcrumb.asCustomComponent,
    rest = _objectWithoutProperties(breadcrumb, _excluded);
  if (asCustomComponent) {
    return /*#__PURE__*/React.createElement("div", {
      className: "cds--link"
    }, value);
  }
  if (asButton) {
    return /*#__PURE__*/React.createElement("button", {
      className: "cpc--page-header__breadcrumb-btn",
      type: "button",
      onClick: onClick
    }, value);
  }
  return /*#__PURE__*/React.createElement(LinkComponent, _extends({
    className: "cds--link",
    tabIndex: 0,
    onClick: onClick,
    href: href
  }, rest), value);
};
var Breadcrumbs = function Breadcrumbs(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    breadCrumbClass = _ref.className,
    _ref$linkComponent = _ref.linkComponent,
    LinkComponent = _ref$linkComponent === void 0 ? 'a' : _ref$linkComponent;
  return /*#__PURE__*/React.createElement(Breadcrumb, {
    className: "cpc--page-header__breadcrumb"
  }, breadcrumbs.map(function (breadcrumb) {
    var value = breadcrumb.value;
    return /*#__PURE__*/React.createElement("li", {
      className: classnames('cds--breadcrumb-item', breadCrumbClass),
      key: value
    }, getBreadcrumbValue(breadcrumb, LinkComponent));
  }));
};
Breadcrumbs.propTypes = {
  /**
   * A navigational aid to allow users to know what page they are on in relation to the site structure.
   */
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    onClick: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    asButton: PropTypes.bool,
    asCustomComponent: PropTypes.bool
  })).isRequired,
  /**
   * The class name to apply to the nav item's li element.
   */
  className: PropTypes.string,
  /**
   * A component or element to use for the link element. If you're using something like React Router this can be a helpful backdoor to pass
   * in your own component, so the page doesn't re-render.
   */
  linkComponent: PropTypes.elementType
};
var Breadcrumbs$1 = Breadcrumbs;

export { Breadcrumbs$1 as default };
